import { User, Vehicle } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { UserVehicleEntityConfig } from "./config";
import { UserVehicleFilters } from "./filters";
import { UserVehicleMethods } from "./methods";

@HyperEntity("user-vehicle", UserVehicleEntityConfig)
export class UserVehicle extends extender(
  UserVehicleFilters,
  UserVehicleMethods,
) {
  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Fields.string({ dbName: "vehicle_id" })
  vehicleId = "";

  @Relations.toOne<UserVehicle, Vehicle>(() => Vehicle, "vehicleId")
  vehicle?: Vehicle;

  @Relations.toOne<UserVehicle, User>(() => User, "userId")
  user?: User;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
